export type MediaType = 'image' | 'pdf' | 'video' | '';

export enum MediaPosition {
  Center,
  Cover,
}

export enum CoverOption {
  Default,
  Custom,
}

export enum AnchorPosition {
  TopRight,
  TopCenter,
  TopLeft,
  MiddleRight,
  MiddleCenter,
  MiddleLeft,
  BottomRight,
  BottomCenter,
  BottomLeft,
}

export type VideoTypeDetails = {
  shouldAutoplay: boolean;
  shouldLoop: boolean;
  thumbnailUrl: string;
};

export type ImageTypeDetails = {
  redirectLink: string;
};

export type Media = {
  url?: string;
  alt?: string;
  position?: MediaPosition;
  videoTypeDetails?: VideoTypeDetails;
  imageTypeDetails?: ImageTypeDetails;
};

export type LandingPageData = {
  media?: Media;
  image?: Media;
  content?: any;
  anchorPosition?: AnchorPosition;
  selectedOption: CoverOption;
};

export interface ProgramPayload {
  title: string;
  landingPage: LandingPageData;
  sport: {
    clientSportId: number;
  };
  publishDate: string;
}
